import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import diContainer from "true-di";
import diContext from "@insightfulscience/smart-react/di-context/context";

import { serviceCore } from "@src/services";

const WithClientSideServices = services => Page => {
	const DiPage = pageProps => {
		const container = useMemo(
			() =>
				diContainer({
					...serviceCore,
					...services,
					globalContext: () => ({
						req: null,
						res: null,
					}),
				}),
			[],
		);

		const [state, setState] = useState(pageProps);
		const stateRef = useRef();

		stateRef.current = state;

		const updateState = useCallback(
			statePatch => {
				const newState =
					typeof statePatch === "function" ? statePatch(stateRef.current) : statePatch;
				stateRef.current = newState;
				setState(newState);
			},
			[setState],
		);

		useEffect(() => {
			if (state === pageProps) return;
			updateState(pageProps);
		}, [pageProps]);

		const run = React.useCallback(
			fn => fn(container, stateRef.current, run, updateState),
			[container], // deps
		);

		return (
			<diContext.Provider value={{ run, data: state, container, setState: updateState }}>
				<Page {...pageProps} />
			</diContext.Provider>
		);
	};

	return DiPage;
};

export default WithClientSideServices;
